export var getDisplayName = function getDisplayName(userInfo) {
  if (userInfo.firstName && userInfo.lastName) return userInfo.firstName + ' ' + userInfo.lastName;
  if (userInfo.firstName) return userInfo.firstName;
  if (userInfo.lastName) return userInfo.lastName;
  return userInfo.userName || '';
};